import React from 'react';

export const ArhidekoLogo: React.FC = () => (
  <div style={{ height: '110px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <img
      src="/images/logos/arhideko-logo-v2.png"
      alt="Arhideko"
      width={300}
      height={110}
      className="dark:hidden"
      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
    />
    <img
      src="/images/logos/arhideko-logo-v2-dark.png"
      alt="Arhideko"
      width={300}
      height={110}
      className="hidden dark:block"
      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
    />
  </div>
);
